// Registers the production service worker. Skipped in development so HMR
// keeps working as expected.
export function registerServiceWorker() {
  if (typeof window === "undefined") return;
  if (!("serviceWorker" in navigator)) return;
  if (process.env.NODE_ENV !== "production") return;

  window.addEventListener("load", () => {
    navigator.serviceWorker
      .register("/service-worker.js")
      .catch((err) => {
        // Failure to register is non-fatal; the site works without it.
        if (process.env.NODE_ENV !== "production") {
          console.warn("[pwa] service worker registration failed", err);
        }
      });
  });
}
